<template>
  <router-view />
</template>

<script setup>
import { onMounted } from 'vue'

onMounted(() => {
  // 添加全局错误处理器
  window.addEventListener('error', (event) => {
    console.error('全局错误:', event.error)
  })
  
  window.addEventListener('unhandledrejection', (event) => {
    console.error('未处理的Promise拒绝:', event.reason)
  })
})
</script>

<style>
/* 基础样式已在全局样式文件中定义 */
</style>